exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-light-2[data-v-16bc3d50]{border-color:#e9ecef}", ""]);

// exports
